<template>
  <a-layout-content>
      <h2>资金排行</h2>
      <a-table :columns="columns" :dataSource="data" size="middle" pagination=0 >
        <span slot="difference" slot-scope="difference">
          <font class="green-D" v-if="difference>0">+{{difference}}</font>
          <font class="red-D" v-else-if="difference<0">{{difference}}</font>
          <font class="silver" v-else>{{difference}}</font>
        </span>
      </a-table>
  </a-layout-content>
</template>
<script>
const columns = [{
  title: '用户名',
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  title: '资金',
  dataIndex: 'money',
  key: 'money',
  align: 'center'
}, {
  title: '资金变化',
  dataIndex: 'difference',
  key: 'difference',
  align: 'center',
  scopedSlots: { customRender: 'difference' }
}, {
  title: '上轮竞拍结果',
  dataIndex: 'is_win',
  key: 'is_win',
  align: 'center'
}]

export default {
  data () {
    return {
      data: [],
      columns,
      cid: ''
    }
  },
  created () {
    this.$http.get('https://auction-api.joyland.top/player?cid=' + this.$route.params.id).then(res => {
      this.data = res.data
    })
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    }
  }
}
</script>

<style>
  .green-D {color: #01CB99!important;;}
  .red-D {color: #D04957!important;;}
  .silver {color: #C0C0C0!important;;}
</style>
